import React, { useEffect, useState } from "react";
import "./checkout-details.scss";
import { useSelector } from "react-redux";
import useShippingLabel from 'hooks/useShippingLabel';
import { useLocation } from 'react-router-dom';

const CheckoutDetails = () => {
  const { isFollowedEbtPayment } = useSelector(({ checkout }) => checkout);
  const { storeDetails } = useSelector(({ store }) => store);
  const { state } = useLocation();
  const [ebtPaymentErrorMessage, setEbtPaymentErrorMessage] = useState(null);

  useEffect(() => {
    if (state && state.ebtPaymentErrorMessage) {
      setEbtPaymentErrorMessage(state.ebtPaymentErrorMessage);
    }
  }, [state]);

  const { shippingLabelLower } = useShippingLabel()
  
  const shippingMethod =
    storeDetails?.allow_pickup === "1" && storeDetails?.allow_delivery === "1"
      ? `pickup or ${shippingLabelLower}`
      : storeDetails?.allow_pickup === "1"
      ? "pickup"
      : storeDetails?.allow_delivery === "1"
      ? shippingLabelLower
      : "";

  const modifyOrderId = useSelector(({ checkout }) => checkout.modifyOrderId);
  return (
    <div className="checkout-details-section" id="checkout-details-section">
      <div className="container">
        <div className="page-title">
          <h1>Checkout {modifyOrderId ? <span className="cart-order-id">(Order #{modifyOrderId})</span> : null}</h1> 
        </div>
        <div className="enter-code-coupon">
          <p>
             <GetMessage 
              isFollowedEbtPayment={isFollowedEbtPayment} 
              ebtPaymentErrorMessage={ebtPaymentErrorMessage} 
             />
          </p>
        </div>
      </div>
    </div>
  );
};

function GetMessage({
  isFollowedEbtPayment,
  ebtPaymentErrorMessage,
}) {
  let message = ""
  if (ebtPaymentErrorMessage) {
    message = ebtPaymentErrorMessage
  } else if (isFollowedEbtPayment) {
    message =
      "Your EBT payment is successful. Complete the remaining amount payment by credit card to place an order."
  }

  const { shippingLabelLower } = useShippingLabel()
  const checkoutStoreType = useSelector(({ checkout }) => checkout?.checkoutStoreType);

  if (message) {
    return (
      <span style={{fontSize: "1.4rem", fontWeight: "bold"}}>{message}</span>
    )
  }

  let shippingOrDelivery = ""
  if (checkoutStoreType === "store_pickup") {
    shippingOrDelivery = "pickup"
  } else if (checkoutStoreType === "delivery") {
    shippingOrDelivery = shippingLabelLower
  }

  return <span>Choose a date and time for {shippingOrDelivery} and place your order.</span>
}

export default CheckoutDetails;
